export const isProjectOwner = (userId, projectUsers, isManagerOrAdmin) => {
  if (!userId || !projectUsers) return false;

  return Boolean(
    isManagerOrAdmin ||
      (projectUsers.author && userId === projectUsers.author.id) ||
      (projectUsers.owner && userId === projectUsers.owner.id)
  );
};
